// extracted by mini-css-extract-plugin
export default {"loader":"LoadingBox_loader__R1OuX","shadow324":"LoadingBox_shadow324__qDDop","jump7456":"LoadingBox_jump7456__dNlyg"};